import { Button, Card, Checkbox, Col, Form, Row, message } from "antd";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../../../firebase";

const NonRevenueStatus = ({ data, dataId, isUpdate,companyName }) => {
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const initialValues = {
    rentReady: data?.nonRevenueUnit || false,
  };

  const onFinish = (values) => {
    console.log("Success:", values);

    isUpdate(true);
    setIsWaiting(true);
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertyDocRef = doc(companyDocRef, "properties", dataId);
      updateDoc(propertyDocRef, {
        "nonRevenueStatus.nonRevenueUnit": values.nonRevenueUnit,
      });
      message.success("None Revenue Unit Data Updated Successfully", 3);

      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
    } catch (error) {
      console.error("not updated:", error);
      message.error("Failed to update None Revenue Unit data", 3);

      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setIsWaiting(false);
  };

  return (
    <div>
      <Card
        title="Non-Revenue Status"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <b>Current</b>
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          initialValues={initialValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Non-Revenue Unit"
            name="nonRevenueUnit"
            valuePropName="checked"
          >
            {isEditActive ? (
              <Checkbox></Checkbox>
            ) : (
              <p>{data?.nonRevenueUnit ? "Yes" : "No"}</p>
            )}
          </Form.Item>
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default NonRevenueStatus;
